module.exports = __webpack_public_path__ + "img/icon-expantion.3c1080ae.svg";